import React, { useState } from 'react';
import {
  useFloating,
  autoUpdate,
  offset,
  flip,
  shift,
  useHover,
  useFocus,
  useInteractions,
  safePolygon,
  FloatingPortal,
} from '@floating-ui/react';

/* v8 — Floating UI replaces the hand-rolled absolute positioning. Automatic
   edge detection, flipping, and shifting kills the recurring clipping bug. */
export default function Popover({ children, content, maxWidth = 340, align = 'left' }) {
  const [open, setOpen] = useState(false);
  const placement = align === 'right' ? 'bottom-end' : 'bottom-start';

  const { refs, floatingStyles, context } = useFloating({
    open,
    onOpenChange: setOpen,
    placement,
    middleware: [offset(6), flip(), shift({ padding: 8 })],
    whileElementsMounted: autoUpdate,
  });

  const hover = useHover(context, {
    delay: { open: 0, close: 80 },
    handleClose: safePolygon(),
  });
  const focus = useFocus(context);
  const { getReferenceProps, getFloatingProps } = useInteractions([hover, focus]);

  return (
    <>
      <span
        ref={refs.setReference}
        className="inline-flex items-baseline"
        {...getReferenceProps()}
      >
        {children}
      </span>
      {open && (
        <FloatingPortal>
          <span
            ref={refs.setFloating}
            style={{ ...floatingStyles, maxWidth }}
            className="z-[60] min-w-[240px] bg-[#0f172a] text-[#e2e8f0] border border-[#334155] rounded-[10px] shadow-[0_10px_30px_rgba(0,0,0,0.45)] px-[14px] py-3 text-[12px] leading-[1.5] text-left whitespace-normal"
            {...getFloatingProps()}
          >
            {content}
          </span>
        </FloatingPortal>
      )}
    </>
  );
}
